import React from "react";
import InfoSection from "./InfoSection";
import EditableInfoRow from "./EditableInfoRow";

const COMPLEX_TYPES = [
    { id: "RESIDENTIAL", name: "Residential" },
    { id: "COMMERCIAL", name: "Commercial" },
    { id: "MIXED", name: "Mixed" },
    { id: "COOPERATIVE", name: "Cooperative" }
];

const BasicInformation = ({ data, isEditing, isLoading, onEdit, onSave, onCancel, onChange }) => {
    const basicInfo = data || {};

    return (
        <InfoSection
            title="Basic Information"
            icon="solar:clipboard-text-bold"
            isEditing={isEditing}
            isLoading={isLoading}
            onEdit={onEdit}
            onSave={onSave}
            onCancel={onCancel}
        >
            <div className="row">
                <EditableInfoRow
                    label="Builder Name"
                    value={basicInfo.builderName}
                    icon="solar:user-rounded-bold-duotone"
                    colSize="col-md-6"
                    isEditing={isEditing}
                    fieldKey="builderName"
                    onChange={onChange}
                />
                <EditableInfoRow
                    label="Complex Type"
                    value={basicInfo.complexType}
                    displayValue={COMPLEX_TYPES.find(t => t.id === basicInfo.complexType)?.name || basicInfo.complexType}
                    icon="solar:buildings-bold-duotone"
                    colSize="col-md-6"
                    isEditing={isEditing}
                    fieldKey="complexType"
                    onChange={onChange}
                    type="select"
                    options={COMPLEX_TYPES}
                    optionLabel="name"
                    optionValue="id"
                    placeholder="Select complex type"
                />
            </div>
        </InfoSection>
    );
};

export default BasicInformation;
